<template>
    <div class="go-wizard-body">
        <div class="go-wizard-title" v-if="title.length > 0">{{ title }}</div>
        <div class="go-wizard-panel-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "go-wizard-panel",
        data: function () {
            return {};
        },
        props: {
            title: {
                type: String,
                default: ""
            }
        },

        computed: {},
        methods: {},
        mounted() {
        },
        watch: {},
        updated() {
        }
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/layoutVue/go-wizard-panel.vue